import { useStableCallback } from "@bezoned/shared/hooks/use-stable-callback.js";
import { routes } from "@bezoned/shared/routes.js";
import {
  Body1,
  Button,
  Card,
  CardFooter,
  CardHeader,
  Link,
  Title3,
} from "@fluentui/react-components";
import { useLocation, useNavigate } from "react-router-dom";

import { updateSearchParams } from "../../utils/url-search-params.js";
import { STARTER_DEFAULT_OFFICE_ONLY_SCREEN_BODY } from "../subscription/starter-plan-copy.js";

export const FeatureNotAvailableScreen = ({
  reason,
}: {
  reason?: string | null;
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isStarterDefaultOfficeOnly = reason === "starter_default_office_only";
  const handleClick36 = useStableCallback(() =>
    navigate(
      `${routes.protected.chooseTeam}${updateSearchParams(location.search, {
        remove: ["teamId"],
      })}`
    )
  );

  return (
    <div className="flex min-h-screen w-full items-center justify-center p-4">
      <Card className="w-full max-w-md" size="large">
        <CardHeader header={<Title3>Feature unavailable</Title3>} />

        <Body1>
          {isStarterDefaultOfficeOnly
            ? STARTER_DEFAULT_OFFICE_ONLY_SCREEN_BODY
            : "This office uses features that are not included in your current subscription plan. Please upgrade or contact your administrator for assistance."}
        </Body1>

        <CardFooter className="flex items-center justify-between">
          <Link href={routes.external.bezoned.pricing} target="_blank">
            Upgrade
          </Link>

          <Button appearance="primary" onClick={handleClick36} type="button">
            Back to lobby
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
};
